import { BOOT_ERROR_ID, BOOT_LOADER_ID } from '@/constants';

import('./bootstrap')
  .then((bootstrap) => bootstrap.appMounted)
  .catch((error) => {
    console.error('[boot] Failed to start the app:', error);
    document.getElementById(BOOT_LOADER_ID)?.remove();
    document.getElementById(BOOT_ERROR_ID)?.removeAttribute('hidden');
  });
